import React from "react";
import styles from "./Checkbox.module.scss";
import { ReactComponent as CheckmarkIcon} from "../../images/svg/checkmark.svg"
import classNames from "classnames";

function Checkbox(props) {
    const {
        id,
        label,
        className,
        onChange,
        checked,
    } = props;

    const _onChange = (e) => {
        if (onChange) {
            onChange(e);
        }
    }

    return (
        <div className={classNames(styles.inputContainer, className)}>            
            <input id={id} type="checkbox" className={styles.input} onChange={_onChange} checked={checked} />            
            <CheckmarkIcon />         
            <label for={id} className={styles.label}>
                {label}
            </label>
        </div>
    );
}

export default Checkbox;
